import { createApp } from "vue";
import { createGtm } from "@gtm-support/vue-gtm";
import { createRouter, createWebHistory } from "vue-router";
import "destyle.css";
import "@/styles/recruit_lp/common.scss";
import RecruitLP from "@/RecruitLP.vue";

const app = createApp(RecruitLP);

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: "/recruit",
      component: () => import("../views/recruit_lp/index.vue"),
      name: "recruit_main",
    },
    {
      path: "/recruit/thanks",
      component: () => import("../views/recruit_lp/thanks.vue"),
      name: "recruit_thanks",
    },
  ],
  scrollBehavior(_to, _from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0 };
    }
  },
});
app.use(router);

if (import.meta.env.MODE === "production") {
  const gtm = createGtm({ id: import.meta.env.VITE_GTM_ID });
  app.use(gtm);
}

document.addEventListener("DOMContentLoaded", () => {
  app.mount("#app");
});
